export const CREDIT_CARD_SWIPE_TRACK = {
  ERROR_START: 'é',
  CC_REG_EX_START: /^%.*/,
  CC_REG_EX_FORMAT: /^%B(\d*)\^(.*)\^(\d*)/,
  CC_REG_EX_NEEDED_INPUT: /^%B(\d*)\^.*\^\d{4}.*$/,
};
// %B9999999999999999^CAROLIN/MARK ^2005000000000000000000000000000?;5555555555555555=222222222222222222?
